export default "<router-outlet>\n</router-outlet>"